import profile from '@motionelements/core/src/store/modules/profile.js';

export default {
  namespaced: true,
  state: () => profile.state,
  getters: profile.getters,
  actions: profile.actions,
  mutations: profile.mutations,
};
